import React, { useEffect, useState } from "react";
import { db } from "../../config/firebase";
import { useAuth } from "../../contexts/AuthContext";
import { collection, query, doc, getDocs } from "firebase/firestore";
import "./Todo.css";

const TodoPage = () => {
  const [filteredReminders, setFilteredReminders] = useState([]);
  const [loading, setLoading] = useState(true); // add a loading state
  const { getCurrentUserId } = useAuth();
  const userId = getCurrentUserId();

  useEffect(() => {
    const fetchReminders = async () => {
      if (!userId) {
        return;
      }
      const remindersRef = collection(db, "reminders");
      const docRef = doc(remindersRef, userId);
      const subcollectionRef = collection(docRef, "userReminders");
      const snapshot = await getDocs(subcollectionRef);
      const remindersData = [];
      for (const doc of snapshot.docs) {
        const reminder = { ...doc.data(), id: doc.id };
        const userRemindersRef = collection(doc.ref, "userReminders");
        const userRemindersQuery = query(userRemindersRef);
        const userRemindersSnapshot = await getDocs(userRemindersQuery);
        const userRemindersData = [];
        userRemindersSnapshot.forEach((userReminderDoc) => {
          const userReminder = {
            ...userReminderDoc.data(),
            id: userReminderDoc.id,
          };
          userRemindersData.push(userReminder);
        });
        reminder.userReminders = userRemindersData;
        remindersData.push(reminder);
      }

      const today = new Date();
      const oneDayAgo = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 1
      ).getTime();
      const twoDaysAgo = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 2
      ).getTime();
      const fourDaysAgo = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 4
      ).getTime();
      const sevenDaysAgo = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 7
      ).getTime();
      const fifteenDaysAgo = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 15
      ).getTime();

      const filteredReminders = remindersData.filter((reminder) => {
        const reminderDate = new Date(reminder.date).getTime();
        return (
          reminderDate === fifteenDaysAgo ||
          reminderDate === sevenDaysAgo ||
          reminderDate === fourDaysAgo ||
          reminderDate === twoDaysAgo ||
          reminderDate === oneDayAgo
        );
      });

      setFilteredReminders(filteredReminders);
      setLoading(false); // set loading to false once data has been fetched
    };

    fetchReminders();
  }, [userId]);

  return (
    <div className="todo">
      <h2>Questions to do today</h2>
      {loading ? ( // conditionally render the loading state
        <p>Loading...</p>
      ) : filteredReminders.length === 0 ? (
        <p>You have completed all the tasks 😄</p>
      ) : (
        <ul>
          {filteredReminders.map((reminder) => {
            const reminderDate = new Date(reminder.date);
            const timeElapsed = Date.now() - reminderDate.getTime();
            const totalTime = 15 * 24 * 60 * 60 * 1000; // 15 days in milliseconds
            const progress = Math.min(1, timeElapsed / totalTime);
            const progressBarStyle = {
              width: "100%",
              height: "10px",
              backgroundColor: "#ddd",
              borderRadius: "4px",
              marginTop: "20px",
              marginBottom: "5px",
              position: "relative",
            };

            const progressBarFillStyle = {
              width: `${progress * 100}%`,
              height: "100%",
              backgroundColor: "#255",
              borderRadius: "4px",
              position: "absolute",
              top: 0,
              left: 0,
            };

            const progressText = {
              position: "absolute",
              right: "0",
              top: "-18px",
              color: "#255",
              fontSize: "14px",
              fontWeight: "bold",
            };
            return (
              <li key={reminder.id}>
                <label>
                  <input
                    type="checkbox"
                    name={reminder.id}
                    value={reminder.id}
                  />
                  <strong>{reminder.text}</strong> (
                  {reminderDate.toLocaleDateString()})
                </label>
                <div className="progress-bar" style={progressBarStyle}>
                  <div style={progressBarFillStyle}></div>
                  <span style={progressText}>
                    {Math.round(progress * 100)}%
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default TodoPage;
